import { useIntl } from 'react-intl-next';

import type { SelectionExtension } from '@atlaskit/editor-plugin-selection-extension';
import PlusSquareIcon from '@atlaskit/icon/core/plus-square';

import { messages } from '../messages';

export const useJiraWorkCreateSelectionExtension = (): SelectionExtension => {
	const { formatMessage } = useIntl();
	return {
		name: formatMessage(messages.singleCreateWorkItemName),
		icon: PlusSquareIcon,
	};
};
